import { render } from "./PolicySupportInfo.vue?vue&type=template&id=0e748576"
import script from "./PolicySupportInfo.vue?vue&type=script&lang=js"
export * from "./PolicySupportInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__